import AiSearchUuid from '../AiSearchUuid';
import DropBoxSearch from '../DropBoxSearch';

export default function SearchV1List({ prefixCls }: { prefixCls: string }) {
    return (
        <>
            <div className={`${prefixCls}-search`}>
                <DropBoxSearch />
            </div>
            <AiSearchUuid />
        </>
    );
}
